module.exports = __webpack_public_path__ + "media/images/riders/small/DAKOTAH_NORTON-dac08cd5e5c614f30012c82d9337b2d4.png";